import { render } from "./g-cookie-consent.vue?vue&type=template&id=1bce37dd&ts=true"
import script from "./g-cookie-consent.vue?vue&type=script&lang=tsx"
export * from "./g-cookie-consent.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__